export const LABELS = {
  TITLE: 'Something went wrong',
  HELP_MESSAGE: 'If this is a recurring issue you can report it by clicking the button below',
  REPORT_ISSUE: 'Report issue',
};
